/**
 * quote products using spree quote services,
 * remember configure automatic_quote-config
 */
import axios from 'axios'


const base = () => {
  return axios.create({
    baseURL: '/bundle/',
  })
}

export const doUploadProjectFile = async (file, parameters, descompress, bundle_number, variant_id, token) => {
  const formData = new FormData();

  formData.append('authenticity_token', token);
  formData.append('parameters[part_number]', parameters.part_number);
  formData.append('parameters[revision]', parameters.revision);
  formData.append('parameters[filename]', file);
  formData.append('parameters[descompress]', descompress);

  formData.append('bundle_number', bundle_number);
  formData.append('variant_id', variant_id);

  try {
    return (await base().post('', formData)).data;
  } catch (err) {
    throw err
  }
}

export const doEmailQuoteRequest = async (body, token) => {
  const data = {...body, authenticity_token: token}
  const response = await axios.post('/product_quote_email_requests', data)
  return response.data
}
